import React, { useEffect, useCallback } from "react";
import useWindowDimensions from "../hooks/useWindowDimensions";
import globalState from '../state/GlobalState';
import { useState as useGlobalState } from '@hookstate/core';
import { useTranslation } from 'react-i18next';
import * as rdd from 'react-device-detect';
import isWebview from 'is-ua-webview';
import NavigationHelper from '../utils/NavigationHelper';
import BellIcon from '../assets/img/svg/bell.svg';
import ProfileIcon from '../assets/img/svg/profile.svg';
import ChiliNoLogo from '../assets/img/svg/ChiliNoLogoSmall.svg';
import IconButton from '@material-ui/core/IconButton';
import { Grid } from "@material-ui/core";
import { Link } from 'react-tiger-transition';
import MenuBar from './MenuBar';

const nh = NavigationHelper;
const TopContainer = (props) => {
    const wDim = useWindowDimensions();
    const gstate = useGlobalState(globalState);
    const { t } = useTranslation();
    useEffect(() => {
        // code to run on component mount
        const scrollToTop = function () {
            setTimeout(
                function () {
                    window.scrollTo(0, 1);
                },
                10
            );
        }
        setCurrentIndex();
        scrollToTop();
        setTopLevelInfo();
    }, [setCurrentIndex])

    const setCurrentIndex = useCallback(() => {
        var ci = nh.getPageIndex(window.location.pathname);
        gstate.currentIndex.set(ci);
    }, []);

    const setTopLevelInfo = function () {
        var ci = gstate.currentIndex.get();
        var cn = t(nh.getPageName(ci));
        var cp = nh.getPageUrl(ci);
        gstate.topModuleName.set(cn);
        gstate.topModuleUrl.set(cp);
    }
    return (
        <div style={{ overflowY: rdd.isFirefox ? 'auto' : wDim.desktop ? 'overlay' : 'scroll', height: wDim.height, WebkitOverflowScrolling: 'touch', scrollbarWidth: rdd.isFirefox ? 'thin' : null }} className={props.noSelect ? 'noselect' : ''}>
            <MenuBar />
            {wDim.desktop && <div style={{ width: '100%', height: '92px' }} />}
            {rdd.isIOS && isWebview && <div style={{ width: '100%', height: '10px' }} />}
            <Grid container direction="row" justify="space-around" alignItems="center">
                <div style={{ maxWidth: wDim.desktop ? '720px' : 'unset', width: '100%', padding: wDim.width <= 320 ? '35px 7px' : '35px 17px' }}>
                    <Grid container direction="row" justify="space-between" alignItems="center">
                        <div style={{ width: '50px' }}><div style={{ marginLeft: '10px' }}>{/*props.bell && <img src={BellIcon} height="32" alt="" />*/}</div></div>
                        {props.logo && <div style={{ width: wDim.desktop ? '65px' : '54px' }}><img src={ChiliNoLogo} height={wDim.desktop ? "41" : "32"} alt="" /></div>}
                        {props.title && <div style={{ fontSize: '20px', fontWeight: '700' }}>{props.title}</div>}
                        {props.hideprofile ? <div style={{ width: '50px' }} /> : <div style={{ width: '50px' }}><Link replace style={{ marginRight: '10px' }} to="/profile" transition="glide-left"><IconButton><img src={ProfileIcon} height="32" alt="" /></IconButton></Link></div>}
                    </Grid>
                    <Grid container direction="column" justify="space-around" alignItems="center" style={{ paddingTop: '25px' }}>
                        {props.children}
                    </Grid>
                </div>
            </Grid>
            {!wDim.desktop && <div style={{ width: '100%', height: '92px' }} />}
        </div>
    );
};

export default TopContainer;